// extracted by mini-css-extract-plugin
export var boxContainer = "RemainingBoxes_boxContainer__0-NTW";
export var container = "RemainingBoxes_container__khjCD";
export var lg = "992px";
export var shared = "\"../shared.module.css\"";